<script setup lang="ts">
import { useSubCardHeadingLevel } from "./headingLevel";

/**
 * A heading nested inside a card, one level below `CardHeading`. Only the 3D model step needs it.
 *
 * Same reason `CardHeading` exists and same shape: it renders the right ELEMENT for wherever the
 * step is being hosted, and carries no styling, so the swap changes nothing but the tag.
 */
const headingLevel = useSubCardHeadingLevel();
</script>

<template>
  <component :is="headingLevel">
    <slot />
  </component>
</template>
